import alert from '@/views/mixins/alert'
import loading from '@/views/mixins/loading'
import constant from '@/views/mixins/constant'
import permissoesMixin from '@/views/mixins/permissoes-mixin'

export default {
	install(Vue) {
		Vue.mixin(alert)
		Vue.mixin(loading)
		Vue.mixin(constant)
		Vue.mixin(permissoesMixin)
	},
}
